"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const ka_js_1 = require("flatpickr/dist/l10n/ka.js");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const react_flatpickr_1 = tslib_1.__importDefault(require("react-flatpickr"));
const PlaceholderLoading_1 = tslib_1.__importDefault(require("src/components/loadings/PlaceholderLoading"));
const UnderlineErrorTest_1 = tslib_1.__importDefault(require("../errors/UnderlineErrorTest"));
const FlatpickrDate = (props) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const disabledClassName = props.disabled ? ' disabled' : '';
    const error = props.error ? ' is-invalid' : '';
    const style = { right: props.error ? 13 : -5, bottom: -12, transform: 'translate(-50%, -50%)' };
    // const coolDates = [Date.parse(new Date('01-27-2022') as unknown as string)]
    if (props.isFetching) {
        return (0, jsx_runtime_1.jsx)(PlaceholderLoading_1.default, { height: 38.4, containerClassName: 'd-block', containerStyle: { borderRadius: '0.42rem' } });
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_flatpickr_1.default
            // onDayCreate={function(_dObj, _dStr, _fp, dayElem) {
            //   if (coolDates.indexOf(+dayElem.dateObj) !== -1) {
            //     dayElem.className += " cool-date";
            //     const toolTip = document.createElement('span');
            //     toolTip.innerHTML = 'Oh hi there.';
            //     dayElem.appendChild(toolTip);
            //   }
            // }}
            , { 
                // onDayCreate={function(_dObj, _dStr, _fp, dayElem) {
                //   if (coolDates.indexOf(+dayElem.dateObj) !== -1) {
                //     dayElem.className += " cool-date";
                //     const toolTip = document.createElement('span');
                //     toolTip.innerHTML = 'Oh hi there.';
                //     dayElem.appendChild(toolTip);
                //   }
                // }}
                name: props.name, options: {
                    dateFormat: props.dateFormat || 'd-m-Y',
                    minDate: props.minDate || undefined,
                    maxDate: props.maxDate,
                    mode: props.range || 'single',
                    // disable: [
                    //   date => (date.getDay() === 0 || date.getDay() === 6),
                    //   // new Date('01-27-2022'), '10-01-2022'
                    // ],
                    locale: { firstDayOfWeek: 1, ...ka_js_1.Georgian }
                }, value: props.value || undefined, onChange: (_dateObject, date) => props.setFieldValue(props.name, date), className: (props.className || 'form-control') + disabledClassName + error, id: props.id || props.name, disabled: props.disabled, placeholder: props.placeholder || translate('choose_date', 'აირჩიეთ თარიღი') }), props.isClearable && props.value
                ? (0, jsx_runtime_1.jsx)("i", { style: { ...style, ...props.style }, className: 'fas fa-times position-absolute p-2 pointer zindex-5', onClick: () => props.setFieldValue(props.name, null) })
                : null, (0, jsx_runtime_1.jsx)(UnderlineErrorTest_1.default, { errorMessage: props.error })] }));
};
exports.default = FlatpickrDate;
